import { getRandomId } from "../../../utils/random-id";
import { Component, FormCreationData } from "./types"

export const buildFields = (fields: string[], parentId: string, array: any[] = [], components: Component, fieldsArray: any[] = []) => {
  fields.forEach((fieldId: string) => {
    const field = {
      ...components[fieldId],
      id: getRandomId(),
      parentId,
    };
    array.push(field);
    fieldsArray?.push(field.id);
    if (field.fields && field.fields.length) {
      const resultantArray: string[] = buildFields(field.fields, field.id, array, components, []);
      field.fields = resultantArray;
    }
  })
  return fieldsArray;
}

export const getParentId = (originalComponent: { [x: string]: FormCreationData; }, selectedData: any) => {
  const { parentId } = originalComponent[selectedData];
  return parentId;
}